import { useState } from 'react';

interface CopyButtonProps {
  label: string;
  value?: string | null;
}

/** Copy-to-clipboard control for a reference value. Hidden when there is no value. */
export function CopyButton({ label, value }: CopyButtonProps): JSX.Element | null {
  const [copied, setCopied] = useState(false);
  if (!value) return null;

  const onCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onCopy}
      aria-label={`Copy ${label}`}
      className="inline-flex items-center gap-1 rounded border border-slate-500 bg-slate-800 px-2 py-1 text-xs hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-kore-accent"
    >
      {copied ? 'Copied' : `Copy ${label}`}
    </button>
  );
}
